import OrderBanner from './OrderBanner';

export default OrderBanner;
